<script>
	import { fade } from 'svelte/transition';
	export let transitionType = 'fade';
	export let inDuration = 400;
	export let outDuration = 200;

	const transitionsMap = {
		fade: fade,
	};

	let transition = transitionsMap[transitionType];
</script>

<div
	class="width-full"
	in:fade={{
		duration: inDuration,
	}}
	out:fade={{
		duration: outDuration,
	}}
>
	<slot />
</div>
